module.exports = __webpack_public_path__ + "band_0.9591c410.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_0.png
// module id = W+NM
// module chunks = 0